module.exports = __webpack_public_path__ + "static/media/motorcycle-chopper.0977adf2.png";